<template>
  <div
    class="rating"
  >
    <div class="review-wrapper">
      <div
        class="review-star-filled-small"
        aria-label="review star filled"
      />
      <div :class="[`rating-block rating-block-small`]">
        <span
          :class="['rating-average', { 'rating-block-margin': reviewLink }]"
        >
          {{ formattedRating }}
        </span>
        <span
          class="rating-description"
        >
          (<component
            :is="'span'"
            :class="['underline']"
          > {{ reviewCount.toLocaleString()
          }}</component>)
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  rating: {
    required: false,
    type: Number,
    default: 0,
  },
  reviewCount: {
    required: false,
    type: Number,
    default: 0,
  },
  showReviewsCount: {
    required: false,
    type: Boolean,
    default: true,
  },
  reviewLink: {
    required: false,
    type: String,
    default: null,
  },
});

const formattedRating = computed(() => (props.rating % 1 === 0 ? props.rating : Math.round(props.rating * 10) / 10));
</script>

  <style scoped>
  .review-wrapper {
    display: flex;
    align-items: center;
    gap: 2px;
    align-self: stretch;
  }
  .underline {
    text-decoration: underline;
  }
  </style>
